import {Icon} from '@ezcater/tapas';
import useTranslation from 'next-translate/useTranslation';

import {type HelpCenterCollection} from '@/utils/helpCenter/types';
import {collectionIcon} from './collectionIcons';

type CategoryGridProps = {
  collections: HelpCenterCollection[];
  onSelect: (collection: HelpCenterCollection) => void;
};

const CategoryGrid: React.FC<CategoryGridProps> = ({collections, onSelect}) => {
  const {t} = useTranslation('common');

  return (
    <ul className="grid grid-cols-1 gap-4 tablet:grid-cols-2" data-testid="help-category-grid">
      {collections.map(collection => (
        <li key={collection.id}>
          <button
            type="button"
            onClick={() => onSelect(collection)}
            className="flex h-full w-full flex-col gap-2 rounded-2xl border border-peppercorn-100 p-4 text-left transition-colors hover:bg-peppercorn-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700 focus-visible:ring-offset-2"
            data-testid="help-category-card"
          >
            <span className="flex items-center gap-3">
              <Icon
                icon={collectionIcon(collection.name)}
                size="small"
                className="text-peppercorn-800"
              />
              <span className="text-base font-bold text-peppercorn-800">{collection.name}</span>
            </span>
            <span className="text-sm text-peppercorn-600">{collection.description}</span>
            <span className="mt-auto text-xs font-semibold text-peppercorn-500">
              {t('components.ContactUs.help.articleCount', {count: collection.articleCount})}
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
};

export default CategoryGrid;
